import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Savings from "@/pages/Savings";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Batteries from "@/pages/Batteries";
import Guide from "@/pages/Guide";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const SiteLayout = () => (
  <div className="grain">
    <SmoothScroll />
    <Nav />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/savings" element={<Savings />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/batteries" element={<Batteries />} />
              <Route path="/13-questions" element={<Guide />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
